function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resources = exports.ResourceCard = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Card = require("../Card");
var _CategoryPills2 = require("../CategoryPills");
var _SvgImage = require("../SvgImage");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "category", "linkUrl"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Resources = exports.Resources = {
  app: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/AppIcon.svg")
    }, props));
  }),
  article: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Article.svg")
    }, props));
  }),
  book: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Book.svg")
    }, props));
  }),
  company: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Company.svg")
    }, props));
  }),
  guide: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Guide.svg")
    }, props));
  }),
  nearby: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Nearby.svg")
    }, props));
  }),
  ngo: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Ngo.svg")
    }, props));
  }),
  podcast: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Podcast.svg")
    }, props));
  }),
  presentation: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Presentation.svg")
    }, props));
  }),
  product: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Product.svg")
    }, props));
  }),
  video: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Video.svg")
    }, props));
  }),
  website: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Website.svg")
    }, props));
  }),
  whitepaper: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
      image: require("../../images/Resources/Whitepaper.svg")
    }, props));
  })
};
var ResourceCard = exports.ResourceCard = (0, _react.memo)(function (_ref) {
  var title = _ref.title,
    category = _ref.category,
    linkUrl = _ref.linkUrl,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  var _CategoryPills = (0, _jsxRuntime.jsx)(_CategoryPills2.CategoryPills, {
    categoryPills: [{
      label: t("resourceCard:".concat(category, ".categoryPillLabel")),
      textColor: COLORS.white,
      backgroundColor: COLORS.cherry
    }]
  });
  return (0, _jsxRuntime.jsx)(_Card.Card, Object.assign({
    testID: "ResourceCard",
    CategoryPills: _CategoryPills,
    title: title,
    Image: Resources[category],
    primaryActionLabel: "".concat(t("resourceCard:".concat(category, ".buttonLabel")), ": ").concat(title),
    primaryActionFakeButtonLabel: t("resourceCard:".concat(category, ".buttonLabel")),
    primaryActionLink: linkUrl
  }, props));
});